import { render } from "./MessageInbox.vue?vue&type=template&id=5e537f8c&scoped=true"
import script from "./MessageInbox.vue?vue&type=script&lang=js"
export * from "./MessageInbox.vue?vue&type=script&lang=js"

import "./MessageInbox.vue?vue&type=style&index=0&id=5e537f8c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e537f8c"]])

export default __exports__